import {
  PrescriberCEAssociationAddParams,
  PrescriberCEAssociationRemoveParams
} from '@module-claims/models/prescriber.interface';

export class ClearPrescriberDetails {
  static readonly type = '[ Prescriber ] Clear Prescriber Details';
}

export class GetPrescriberDetails {
  static readonly type = '[ Prescriber ] Get Prescriber Details';

  constructor(public npi: string) {}
}

export class AddPresciberCEAssociation {
  static readonly type = '[ Prescriber ] Add CE Association';

  constructor(public params: PrescriberCEAssociationAddParams) {}
}

export class RemovePresciberCEAssociation {
  static readonly type = '[ Prescriber ] Remove CE Association';

  constructor(public params: PrescriberCEAssociationRemoveParams) {}
}

export class PrescriberCEAssociationModalSave {
  static readonly type = '[ Prescriber ] CE Association modal save event';

  constructor(public params: PrescriberCEAssociationAddParams) {}
}

export class PrescriberCEAssociationModalClose {
  static readonly type = '[ Prescriber ] CE Association modal close event';
}

export class PrescriberCEAssociationRemovalModalSave {
  static readonly type =
    '[ Prescriber ] CE Association removal modal save event';

  constructor(public params: PrescriberCEAssociationAddParams) {}
}

export class PrescriberCEAssociationRemovalModalClose {
  static readonly type =
    '[ Prescriber ] CE Association removal modal close event';
}
